import React from 'react';
import { connect } from 'react-redux';
import { css, StyleSheet } from 'aphrodite/no-important';
import { useLocation } from 'react-router-dom';
import { toggleUserSigninDialog } from '../actions';
import { blue, gray } from '../theme';
import Footer from '../components/footer';

const Home = props => {
  // const typingKeyframes = {
  //   from: { width: 0 },
  //   to: { width: '704px' }
  //   // to: { width: '100%' }
  //   // '50%': { width: '454px' },
  //   // to: { width: 0 }
  // };

  // const blinkCaretKeyframes = {
  //   from: { borderColor: 'transparent' },
  //   '50%': { borderColor: 'white' },
  //   to: { borderColor: 'transparent' }
  // };
  const styles = StyleSheet.create({
    homeContainer: {
      overflowX: 'hidden'
    },
    txtHero: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      // background: blue[500],
      background: gray[700],
      color: blue[400],
      height: '365px',
      '@media (max-width: 574px)': {
        textAlign: 'center'
      }
    },
    // qtxHeading: {
    //   overflow: 'hidden',
    //   fontSize: '2.5rem',
    //   borderRight: '.15em solid white',
    //   whiteSpace: 'nowrap',
    //   margin: '0 auto',
    //   paddingRight: '8px',
    //   letterSpacing: '.1em',
    //   wordSpacing: '.2em',
    //   animationName: [typingKeyframes, blinkCaretKeyframes],
    //   animationDuration: '5s, .75s',
    //   animationTimingFunction: 'steps(28, end), step-end',
    //   animationIterationCount: '1, infinite'
    // },
    textContainer: {
      width: '80%',
      '@media (max-width: 574px)': {
        width: '100%',
        textAlign: 'center'
      }
    },
    content: {
      // height: '735px',
      background: 'white',
      display: 'flex',
      flexFlow: 'column',
      alignItems: 'center',
      '@media (min-width: 574px)': {
        height: '735px'
      }
    }
  });

  const location = useLocation();
  if (location.state && location.state.showSignInDialog) {
    props.toggleUserSigninDialog(location.state.showSignInDialog);
    location.state.showSignInDialog = false;
  }

  return (
    <div className={css(styles.homeContainer)}>
      {/* style={{ marginTop: '40px' }} disabled for now */}
      {/* <Hero
        heroImg='https://quantumtrader.s3.amazonaws.com/hero.jpg'
        showMask
      /> */}
      {/* Hero */}
      <div className={css(styles.txtHero)}>
        <h1>MedPros Healthcare Resources</h1>
      </div>
      {/* Site content */}
      <div className={css(styles.content)}>
        <h2 className='mt-4'>
          MedPros Credentialing Suite
        </h2>
        <div className={css(styles.textContainer)}>
          <p>
            MedPros Credentialing Suite transforms your credentialing process into a seamless, hassle-free experience. Integration with central data sources such as NPPES, FSMB, DEA, and many others makes initial certification, re-certification, and primary source verification a snap.
          </p>
          <p>
            Military-grade 256-bit encryption on HIPAA-comliant Amazon Web Servers provides a central, secure platform for storing sensitive provider data.
          </p>
          <p>
            Our in-app messaging system uses the same security protocols and infrastructure, allowing secure communication between providers and credentialing staff.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
};

function mapStateToProps({ user }) {
  return { ...user };
}

export default connect(mapStateToProps, { toggleUserSigninDialog })(Home);
